
import React from 'react';

const BlogCardSkeleton = () => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg flex flex-col h-full border border-gray-100 dark:border-gray-700 shadow-sm animate-pulse">
      {/* Image area */}
      <div className="w-full h-48 bg-gray-200 dark:bg-gray-700 rounded-t-lg" />
      
      <div className="p-4 flex flex-col flex-1 gap-4">
        <div className="flex justify-between">
          {/* Category badge */}
          <div className="h-6 w-20 bg-gray-200 dark:bg-gray-700 rounded-full" />
          {/* Reading time */}
          <div className="h-6 w-16 bg-gray-200 dark:bg-gray-700 rounded-full" />
        </div>

        {/* Title lines */}
        <div className="space-y-2">
          <div className="h-6 w-full bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-6 w-2/3 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>

        {/* Excerpt lines */}
        <div className="space-y-2 flex-1">
          <div className="h-4 w-full bg-gray-100 dark:bg-gray-700/50 rounded" />
          <div className="h-4 w-full bg-gray-100 dark:bg-gray-700/50 rounded" />
          <div className="h-4 w-4/5 bg-gray-100 dark:bg-gray-700/50 rounded" />
        </div>

        {/* Footer info */}
        <div className="flex justify-between pt-4 border-t border-gray-100 dark:border-gray-700">
          <div className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-4 w-16 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>
      </div>
    </div>
  );
};

export default BlogCardSkeleton;